import { render, staticRenderFns } from "./TopUpWindow.vue?vue&type=template&id=0c0fac0a&scoped=true&slot-scope=scope&"
import script from "./TopUpWindow.vue?vue&type=script&lang=js&"
export * from "./TopUpWindow.vue?vue&type=script&lang=js&"
import style0 from "./TopUpWindow.vue?vue&type=style&index=0&id=0c0fac0a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0fac0a",
  null
  
)

export default component.exports